import type { ProofSpiel } from "./types";

export const proof: ProofSpiel = {
  heading: "Work",

  stats: [
    {
      value: "50,000+",
      label: "paying users served",
      detail: "On live products we built and still run",
    },
    {
      value: "8+",
      label: "companies supported",
      detail: "Across Australia",
      // detail: "Across Australia and the United States",
    },
    {
      value: "3+",
      label: "years shipping as a firm",
      detail: "About a release a week across web and mobile in production",
    },
  ],

  flagship: {
    name: "Australian members-only sports rewards club",
    description:
      "A members-only rewards club: perks, billing, and mobile apps for people paying every month. Built from scratch.",
    owned:
      "Web, iOS, and Android. Subscription and in-app billing, member and admin permissions, a reporting warehouse with custom funnels, automated tests, UI/UX, QA, and member support.",
    outcome:
      "99.99% uptime on peak-traffic days. We ship new features every week.",
    href: null,
  },

  rangeLabel: "Other work",

  range: [
    {
      name: "Australian live-events platform",
      summary:
        "Inherited a product that wasn't shippable. We got the web, iOS, and Android apps stable enough to launch.",
    },
    {
      name: "Australian subscription and events platform",
      summary:
        "Consumer iOS and Android app plus three operator consoles, Stripe subscriptions, Apple and Google Wallet passes, and QR door entry. Two engineers, eight months.",
    },
    {
      name: "Industrial computer-vision portal",
      // name: "US industrial computer-vision portal",
      summary:
        "Camera fleet management and machine-learning defect review with live video through AWS Kinesis, replacing manual eyeball checks on the line.",
    },
    {
      name: "Structural engineering software vendor",
      // name: "US structural engineering software vendor",
      summary:
        "Full rebuild of a legacy web app for timber beam, floor joist, and A-frame design, with licensed multi-user access. We learned enough structural engineering to sit in the client's design meetings.",
    },
  ],
};
